import React from "react";
import { IMaskInput } from "react-imask";

const IMaskInputWrapper = React.forwardRef<HTMLInputElement, any>(
  ({ ...props }, ref) => <IMaskInput {...props} inputRef={ref} />
);

IMaskInputWrapper.displayName = "IMaskInputWrapper";

export default IMaskInputWrapper;
